import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "@/lib/api";

const AuthCtx = createContext(null);

const DEMO_USER = {
  id: "demo-user",
  name: "Pengguna Demo",
  email: "demo@glazytracker.local",
  role: "customer",
  is_demo: true,
  customer_id: "demo-customer",
  customer: {
    id: "demo-customer",
    name: "Armada Demo Glazy Tracker",
    company: "Glazy Tracker Demo",
    active: true,
  },
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loginDraft, setLoginDraft] = useState({ email: "", password: "" });

  const refresh = useCallback(async () => {
    if (window.sessionStorage.getItem("gt_demo_mode") === "1") {
      setUser(DEMO_USER);
      return;
    }
    if (!tokenStore.get()) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password, remember = false) => {
    window.sessionStorage.removeItem("gt_demo_mode");
    const { data } = await api.post("/auth/login", { email, password });
    setLoginDraft({ email, password });
    tokenStore.set(data.token, remember);
    await refresh();
  };

  const enterDemo = () => {
    tokenStore.clear();
    window.sessionStorage.setItem("gt_demo_mode", "1");
    setUser(DEMO_USER);
  };

  const logout = async () => {
    const wasDemo = window.sessionStorage.getItem("gt_demo_mode") === "1";
    window.sessionStorage.removeItem("gt_demo_mode");
    if (!wasDemo) {
      try {
        await api.post("/auth/logout");
      } catch {
        /* token may already be invalid */
      }
    }
    tokenStore.clear();
    setUser(false);
  };

  const isSuperAdmin = user?.is_super_admin === true;
  const isDemo = user?.is_demo === true;
  return <AuthCtx.Provider value={{ user, login, logout, enterDemo, loginDraft, isDemo, isAdmin: user?.role === "admin", isSeller: user?.role === "seller", isSuperAdmin }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
